module.exports = __webpack_public_path__ + "img/blood-sample.08d26f37.png";